var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    class: ['ugc-controls-wrapper', {
      'ugc-controls-wrapper--overflow': _vm.areInstructionsVisible || _vm.isHistoryVisible
    }]
  }, [_vm.areInstructionsVisible ? _c('section', {
    staticClass: "ugc-controls-wrapper-content control"
  }, [_c('div', {
    class: ['ugc-controls-wrapper-content-img', {
      hide: _vm.hideReferenceImg,
      'ugc-controls-wrapper-content-img--second': _vm.returnPlacementViewOrder === 1
    }]
  }, [_c('img', {
    attrs: {
      "src": _vm.setInstructionsImg
    }
  })]), _c('div', {
    class: ['ugc-controls-wrapper-content-instructions', {
      'ugc-controls-wrapper-content-instructions--second': _vm.returnPlacementViewOrder === 1
    }]
  }, [_vm._v("\n      " + _vm._s(_vm.isDesignTransferApplied ? _vm.transferDesignPlacement : _vm.setInstructionsText) + "\n    ")])]) : _vm._e(), _c('ugc-tools-history', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isHistoryVisible,
      expression: "isHistoryVisible"
    }]
  }), _c(_vm.activeControl, {
    tag: "component",
    staticClass: "control"
  }), _c('ugc-tools-confirmation-controls', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showConfirmationControls,
      expression: "showConfirmationControls"
    }]
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }